import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 个人/企业定义
 */
/**
 * 认证模式
 */
class CertificationMode extends UltMeta {
    IVS = new Meta("IVS", "手机三要素认证");
    FACE = new Meta("FACE", "人脸认证");
    BANK = new Meta("BANK", "银行卡认证");
    MANUAL = new Meta("MANUAL", "人工审核");
}
export const CERTIFICATION_MODE = new CertificationMode();

/**
 * 认证状态
 */
class CertificationStatus extends UltMeta {
    PASS = new Meta(1, "认证通过");
    INVALID = new Meta(2, "认证不通过");
}
export const CERTIFICATION_STATUS = new CertificationStatus();

/**
 * 认证组织
 */
class InstitutionType extends UltMeta {
    ENTERPRISE = new Meta(1, "企业");
    INDIVIDUAL_BUSINESS = new Meta(2, "个体工商户");
    PUBLIC_INSTITUTIONS = new Meta(3, "事业单位");
    PERSONAL = new Meta(4, "个人");
}
export const INSTITUTION_TYPE = new InstitutionType();

/**
 * 企业状态
 */
class EnterpriseStatus extends UltMeta {
    NO_CERTIFICATION_RECORD = new Meta(-1, "无认证记录");
    NOT_YET_CERTIFIED = new Meta(0, "未认证");
    UNSUBMITTED_CERTIFICATION_APPLICATION = new Meta(1, "未提交认证申请");
    CERTIFIED = new Meta(2, "认证通过");
    CERTIFICATION_FAILED = new Meta(3, "认证不通过");
    CERTIFICATION_IN_PROGRESS = new Meta(4, "认证中");
    EXPIRED = new Meta(6, "已过期");
}
export const ENTERPRISE_STATUS = new EnterpriseStatus();

class EnterpriseCallbackStatus extends UltMeta {
    UNAUTHENTICATED = new Meta(-1, "未认证");
    CERTIFICATION_IN_PROGRESS = new Meta(0, "认证中");
    PASS = new Meta(1, "认证成功");
    INVALID = new Meta(2, "认证失败");
}
export const ENTERPRISE_CALLBACK_STATUS = new EnterpriseCallbackStatus();

/**
 *
 */
class ActionEvent extends UltMeta {
    SUBMIT_BASIC_INFORMATION = new Meta(0, "提交基本信息");
    BASIC_INFORMATION_REVIEW_PASSED = new Meta(1, "基本信息审核通过");
    BASIC_INFORMATION_REVIEW_FAILED = new Meta(2, "基础信息审核失败");
    AUTHORIZATION_LETTER_REVIEW_FAILED = new Meta(2, "授权书审核失败");
    CERTIFICATION_SUCCESSFUL = new Meta(2, "认证成功");
}
export const ACTION_EVENT = new ActionEvent();

class CertificationHasExpired extends UltMeta {
    EXPIRED = new Meta(1, "已过期");
    NOT_EXPIRED = new Meta(0, "未过期");
}
export const CERTIFICATION_HAS_EXPIRED = new CertificationHasExpired();

class Origin extends UltMeta {
    PC = new Meta(1, "pc 端");
    MINI_APP = new Meta(2, "小程序端");
    SHIP_MINI_APP = new Meta(3, "船务小程序端");
}
export const ORIGIN = new Origin();

class CertificationType extends UltMeta {
    PERSONAL = new Meta(1, "个人");
    ENTERPRISE = new Meta(2, "组织");
}
export const CERTIFY_TYPE = new CertificationType();

// 后台管理 -- 组织机构认证
export enum AUTH_EMTICATION_STATE_MAP {
    NOT_STATE = -1,
    PENDING = 1,
    ERROR = 2,
    SUCCESS = 3
}

// 个人认证
export enum AUTH_PERSON_STATE_MAP {
    PENDING = 0,
    SUCCESS = 1,
    ERROR = 2
}

// 契约锁认证状态
export enum AUTH_EMTICATION_STATE {
    notState = -1,
    pending = 0,
    success = 1,
    error = 2
}
